import React from 'react';
import { ReactComponent as CoralLogo } from './coral-logo.svg';

const Coral_logo_svg = ({ ClassName }) => {
    return <CoralLogo className={ClassName} />;
}

export default Coral_logo_svg;
